/**
 * DevelopedBy — the "Developed by Stirringapps" credit as one plain sentence.
 *
 * "Developed by" is ordinary text. "Stirringapps" is bold and is the only
 * link (new tab to stirringapps.com): the hover colour and underline apply to
 * the name alone, not to the whole sentence. Font size and family are
 * inherited from the parent, so the credit is always the size of the text
 * around it.
 *
 * Props
 *   tone      'dark' | 'light' | 'auto' — colour pair for the surface: public
 *             dark footers (raw greys), public light pages, or the dashboard
 *             (ink tokens, follow the theme).
 *   lang      Optional i18n language override. The landing page keeps its own
 *             language state (not wired to i18next), so it passes `lang`.
 *   className Extra classes on the wrapping <span>.
 */

import { useTranslation } from 'react-i18next'
import { STIRRINGAPPS_NAME, STIRRINGAPPS_URL } from '../../config/brand'

const TONE = {
  dark: { text: 'text-gray-500', link: 'text-gray-400 hover:text-white' },
  light: { text: 'text-gray-600', link: 'text-gray-700 hover:text-gray-900' },
  auto: { text: 'text-ink-muted', link: 'text-ink-secondary hover:text-ink-primary' },
}

export default function DevelopedBy({ tone = 'auto', lang, className = '' }) {
  const { t } = useTranslation()
  const label = t('common.developedBy', lang ? { lng: lang } : undefined)
  const c = TONE[tone] || TONE.auto

  return (
    <span className={`whitespace-nowrap ${c.text} ${className}`}>
      {label}{' '}
      <a
        href={STIRRINGAPPS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`font-bold transition-colors hover:underline underline-offset-2 ${c.link}`}
      >
        {STIRRINGAPPS_NAME}
      </a>
    </span>
  )
}
